import {Component, inject, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import { faPlus } from "@fortawesome/free-solid-svg-icons";
import {SystemManagementService} from "../../../data-access/system-management.service";
import {MenuItem} from "../../../../shared/ui/dropdown-menu/dropdown-menu.component";
import {MatSnackBar} from "@angular/material/snack-bar";
import {Location} from "@angular/common";
import {BreadcrumbNavigation} from "../../../../shared/ui/breadcrumb/breadcrumb.component";

export interface Message {
  message_id: number
  dashboard: string
  msg: string
  start: Date
  end: Date
  active: boolean
  menuItem: MenuItem[]
}
@Component({
    selector: 'announcement-list',
    templateUrl: './announcement-list.component.html',
    styleUrls: ['../../userManagement/userRoleAddEdit/userRoleAddEdit.css'],
    standalone: false
})
export class AnnouncementListComponent implements OnInit {
  router = inject(Router)
  route = inject(ActivatedRoute)
  msg = ''
  systemService = inject(SystemManagementService)
  messages: Message[] = []
  faPlus = faPlus
  _snackBar = inject(MatSnackBar)
  breadcrumbNavs: BreadcrumbNavigation[] = [{
    text: 'System Management',
    route: 'dashboard/SystemManagement'
  }]
  ngOnInit() {
    this.listAnnouncements()
  }

  listAnnouncements() {
    this.systemService.listAllAnnouncements().subscribe((response) => {
      if(response.success) {
        this.messages = []
        for(let result of response.result) {
          this.messages.push({
            ...result,
            menuItem: [{
              title: 'Edit',
              action: () => {
                this.router.navigate(['dashboard/SystemManagement/Announcement/Config'], {queryParams: {'message_id': result.message_id, 'msg': result.msg}})
              }
            },{
              title: 'Delete',
              action: () => {
                this.systemService.deleteAnnouncement(result.message_id).subscribe((response) => {
                  if(response.success) {
                    this._snackBar.open('Announcement successfully deleted', 'Dismiss')
                    this.listAnnouncements()
                  } else {
                    this._snackBar.open(response.msg, 'Dismiss', {panelClass: ['error-snackbar']})
                  }
                })
              }
            }]
          })
        }
      } else {
        this._snackBar.open(response.msg, 'Dismiss', {panelClass: ['error-snackbar']})
      }
    })
  }

  addAnnouncement() {
    this.router.navigate(['dashboard/SystemManagement/Announcement/Config'])
  }
}
